/**
 * Home Page - Using RefineVoice Widget (no more core duplication!)
 */

import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefineVoiceWidget } from '../components/RefineVoiceWidget';
import '@refinevoice/core/styles.css';
import { EditorContext } from '@refinevoice/core';
import { ErrorNotification } from '../components/ErrorNotification';
import { HelpModal } from '../components/HelpModal';
import { HistoricWaveform } from '../components/HistoricWaveform';
import { ManagePromptsModal } from '../components/ManagePromptsModal';
import { PermissionDialog } from '../components/PermissionDialog';
import { SavePromptDialog } from '../components/SavePromptDialog';
import { usePermissionStore } from '../store/usePermissionStore';
import './Home.css';

export function Home() {
  const { t } = useTranslation();
  const { hasGrantedPermission } = usePermissionStore();

  // State for modals
  const [showHelp, setShowHelp] = useState(false);
  const [showManagePrompts, setShowManagePrompts] = useState(false);
  const [showSavePrompt, setShowSavePrompt] = useState(false);
  const [showPermissionDialog, setShowPermissionDialog] = useState(false);

  // Handle transcript changes
  const handleTranscriptChange = useCallback((transcript: string) => {
    // The widget handles all state internally
    console.log('Transcript changed:', transcript);
  }, []);

  // Handle recording state changes
  const handleRecordingStateChange = useCallback((state: string) => {
    console.log('Recording state:', state);
  }, []);

  // Handle refinement
  const handleRefine = useCallback((transcript: string) => {
    console.log('Refinement requested for:', transcript);
  }, []);

  return (
    <>
      <div className="home">
        {/* Main Text Container */}
        <div className="text-container">
          <EditorContext.Provider value={null}>
            <RefineVoiceWidget
              widgetId="home-page-editor"
              onTranscriptChange={handleTranscriptChange}
              onRecordingStateChange={(isRecording) =>
                handleRecordingStateChange(isRecording ? 'recording' : 'idle')
              }
              onRefine={handleRefine}
              className="home-page-widget"
              showRecordingButton={true}
              showRefineButton={true}
              refinePosition="bottom-right"
              ariaLabel={
                hasGrantedPermission
                  ? t('home.placeholder.ready')
                  : t('home.placeholder.permission')
              }
              initialContent=""
            />
          </EditorContext.Provider>
        </div>

        {/* Help Button */}
        <button
          type="button"
          className="help-button"
          onClick={() => setShowHelp(true)}
          aria-label={t('home.help.title')}
        >
          ?
        </button>

        {/* Historic Waveform */}
        <HistoricWaveform />
      </div>

      {/* Modals */}
      {showHelp && <HelpModal isOpen={showHelp} onClose={() => setShowHelp(false)} />}

      {showManagePrompts && <ManagePromptsModal onClose={() => setShowManagePrompts(false)} />}

      {showSavePrompt && (
        <SavePromptDialog promptText="" onClose={() => setShowSavePrompt(false)} />
      )}

      {showPermissionDialog && (
        <PermissionDialog
          isOpen={showPermissionDialog}
          onAccept={() => {
            setShowPermissionDialog(false);
            // Permission granted
          }}
          onDecline={() => setShowPermissionDialog(false)}
        />
      )}

      {/* Error Notifications */}
      <ErrorNotification />
    </>
  );
}
